(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    // Free shipping progress bar.
  // The bar is rendered server-side from Liquid and is correct on first paint.
  // Horizon re-renders the cart-drawer section on add/remove/qty change via the
  // Section Rendering API, so the Liquid recomputes automatically. This script is
  // a defensive enhancement: it re-syncs the fill + message from data-total in case
  // only part of the drawer is patched, and animates the fill on open.
  (function () {
    // MUST MATCH tss_ship_threshold in the Liquid above.
    var THRESHOLD_FALLBACK = 11500; // £115 in pennies

    function formatMoney(pennies) {
      var fmt = (window.Shopify && Shopify.money_format) || '\u00a3{{amount}}';
      var amount = (pennies / 100).toFixed(2);
      return fmt
        .replace(/\{\{\s*amount\s*\}\}/, amount)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(pennies / 100))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(pennies / 100));
    }

    function sync(bar, total) {
      var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || THRESHOLD_FALLBACK;
      if (typeof total !== 'number') {
        total = parseInt(bar.getAttribute('data-total'), 10) || 0;
      }
      bar.setAttribute('data-total', total);

      var remaining = threshold - total;
      var pct = Math.min(100, Math.round((total / threshold) * 100));

      var fill = bar.querySelector('[data-fsb-fill]');
      var msg = bar.querySelector('[data-fsb-msg]');
      var track = bar.querySelector('.tss-fsb__track');

      if (fill) {
        fill.style.width = pct + '%';
        fill.classList.toggle('tss-fsb__fill--done', remaining <= 0);
      }
      if (track) track.setAttribute('aria-valuenow', pct);
      if (msg) {
        if (remaining > 0 && remaining < 100) {
          msg.innerHTML = 'You are pennies away from <strong>free UK shipping</strong>';
        } else if (remaining > 0) {
          msg.innerHTML = 'Spend <strong>' + formatMoney(remaining) + '</strong> more for <strong>free UK shipping</strong>';
        } else {
          msg.innerHTML = '<strong>You have unlocked free UK shipping</strong>';
        }
      }
    }

    if (!customElements.get('free-shipping-bar')) {
      customElements.define('free-shipping-bar', class extends HTMLElement {
        connectedCallback() {
          // Re-sync from the server-rendered data-total on connect (also animates fill).
          var self = this;
          requestAnimationFrame(function () { sync(self); });
        }
      });
    }

    // Fetch the authoritative cart total after any cart change and update every bar.
    function refreshFromCart() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('free-shipping-bar').forEach(function (bar) {
            sync(bar, cart.total_price);
          });
        })
        .catch(function () {});
    }

    // Horizon dispatches cart update events; listen broadly so we catch them.
    ['cart:update', 'cart:refresh', 'cart:change'].forEach(function (evt) {
      document.addEventListener(evt, refreshFromCart);
    });

    // ===== QUICK-ADD DIALOG =====
    // Opens for accessories with more than one variant. Delegated from
    // document, like the add handler, because the drawer markup is replaced
    // after every cart update.
    // The drawer already locks body scrolling while it is open. Blindly
    // clearing overflow on close released that lock too, which let the page
    // behind scroll under an open drawer on mobile. The previous value is
    // saved and put back instead.
    var qaPrevOverflow = null;

    function closeQa() {
      var wasOpen = false;
      document.querySelectorAll('[data-tss-qa]').forEach(function (d) {
        if (!d.hidden) wasOpen = true;
        d.hidden = true;
      });
      if (wasOpen && qaPrevOverflow !== null) {
        document.body.style.overflow = qaPrevOverflow;
        qaPrevOverflow = null;
      }
    }

    // Which slide is currently in view. Measured against each slide's own
    // offsetLeft rather than dividing by the track width, so it stays correct
    // regardless of padding, gaps or a part-scrolled position.
    function qaActiveIndex(track) {
      var slides = track.querySelectorAll('.tss-qa__slide');
      if (!slides.length) return 0;
      var pos = track.scrollLeft;
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var dist = Math.abs(slides[i].offsetLeft - pos);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      }
      return best;
    }

    function qaSyncDots(dlg, index) {
      var track = dlg.querySelector('[data-tss-qa-track]');
      if (!track) return;
      var i = (typeof index === 'number') ? index : qaActiveIndex(track);
      dlg.querySelectorAll('[data-tss-qa-dot]').forEach(function (d, n) {
        d.classList.toggle('on', n === i);
      });
    }

    // Wired when a dialog first opens rather than on load, since the drawer
    // markup is replaced after every cart update and the flag goes with it.
    function wireQaTrack(dlg) {
      var track = dlg.querySelector('[data-tss-qa-track]');
      if (!track || track.dataset.tssWired === '1') return;
      track.dataset.tssWired = '1';

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          qaSyncDots(dlg);
          ticking = false;
        });
      }, { passive: true });
    }

    function qaScrollTo(dlg, index) {
      var track = dlg.querySelector('[data-tss-qa-track]');
      if (!track) return;
      var slides = track.querySelectorAll('.tss-qa__slide');
      if (!slides.length) return;
      if (index < 0) index = 0;
      if (index > slides.length - 1) index = slides.length - 1;

      // Scroll to the slide's own position, and mark the dot immediately so it
      // does not lag behind the smooth scroll.
      track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
      qaSyncDots(dlg, index);

      // Re-check once the scroll has settled, in case it landed elsewhere.
      window.setTimeout(function () { qaSyncDots(dlg); }, 420);
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-tss-acc-open]');
      if (opener) {
        e.preventDefault();
        var dlg = document.getElementById(opener.getAttribute('data-tss-acc-open'));
        if (dlg) {
          dlg.hidden = false;
          if (qaPrevOverflow === null) qaPrevOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
          wireQaTrack(dlg);
          // The track has no measurable width until the dialog is visible, so
          // the dots are synced on the next frame rather than immediately.
          requestAnimationFrame(function () { qaSyncDots(dlg); });
          // Preselect whichever option matches the button's current variant.
          var addBtn = dlg.querySelector('[data-tss-acc-add]');
          var current = addBtn && addBtn.getAttribute('data-variant-id');
          dlg.querySelectorAll('[data-tss-qa-opt]').forEach(function (o) {
            o.classList.toggle('is-selected', o.getAttribute('data-variant-id') === current);
          });
        }
        return;
      }

      if (e.target.closest('[data-tss-qa-close]')) {
        e.preventDefault();
        closeQa();
        return;
      }

      var dot = e.target.closest('[data-tss-qa-dot]');
      if (dot) {
        e.preventDefault();
        var dotDlg = dot.closest('[data-tss-qa]');
        if (dotDlg) qaScrollTo(dotDlg, parseInt(dot.getAttribute('data-tss-qa-dot'), 10) || 0);
        return;
      }

      var opt = e.target.closest('[data-tss-qa-opt]');
      if (opt && !opt.disabled) {
        var panel = opt.closest('[data-tss-qa]');
        if (!panel) return;
        panel.querySelectorAll('[data-tss-qa-opt]').forEach(function (o) {
          o.classList.remove('is-selected');
        });
        opt.classList.add('is-selected');

        var add = panel.querySelector('[data-tss-acc-add]');
        if (add) add.setAttribute('data-variant-id', opt.getAttribute('data-variant-id'));

        var priceEl = panel.querySelector('[data-tss-qa-price]');
        var price = opt.getAttribute('data-price');
        if (priceEl && price) priceEl.textContent = price;

        // Jump to the image for the chosen variant, when it has one.
        var imgId = opt.getAttribute('data-image-id');
        if (imgId) {
          var slides = Array.prototype.slice.call(panel.querySelectorAll('.tss-qa__slide'));
          for (var i = 0; i < slides.length; i++) {
            if (slides[i].getAttribute('data-image-id') === imgId) {
              qaScrollTo(panel, i);
              break;
            }
          }
        }
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeQa();
    });

    // ===== ACCESSORY UPSELL: inline add to cart =====
    // The cards are rendered server-side, so the variant id is already on the
    // button. The handler is delegated from document because the drawer's
    // markup is replaced wholesale after every cart update, which would
    // detach any listener bound directly to a card.
    var accBusy = false;

    function patchDrawer(sections) {
      var html = sections && sections['cart-drawer-section'];
      var live = document.querySelector('cart-drawer-component');
      if (!html || !live) return false;
      try {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('cart-drawer-component');
        if (!fresh) return false;
        live.innerHTML = fresh.innerHTML;
        return true;
      } catch (e) {
        return false;
      }
    }

    // Complete the look / Protect & Care tabs (delegated, the drawer is re-rendered)
    document.addEventListener('click', function (e) {
      var tab = e.target.closest && e.target.closest('[data-tss-cu-tab]');
      if (!tab) return;
      var box = tab.closest('[data-tss-cu]');
      var key = tab.getAttribute('data-tss-cu-tab');
      box.querySelectorAll('[data-tss-cu-tab]').forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      box.querySelectorAll('[data-tss-cu-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-tss-cu-panel') !== key;
      });
    });

    // Complete the look size pickers (snippets/tss-cart-upsell-card.liquid):
    // the picked variant goes onto the card's Add button. Bound here because
    // markup swapped into the drawer does not run its own scripts.
    document.addEventListener('change', function (e) {
      var sel = e.target.closest && e.target.closest('[data-tss-cu-size]');
      if (!sel) return;
      var card = sel.closest('.tss-cu__card');
      var add = card && card.querySelector('[data-tss-acc-add]');
      if (!add) return;
      add.setAttribute('data-variant-id', sel.value);
      add.disabled = !sel.value;
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-tss-acc-add]');
      if (!btn) return;
      e.preventDefault();
      if (accBusy || btn.disabled) return;

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      var label = btn.querySelector('[data-tss-acc-label]') || btn;
      var original = label.textContent;
      accBusy = true;
      btn.disabled = true;
      label.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: 'cart-drawer-section',
          sections_url: window.location.pathname
        })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (err) { throw err; });
          return r.json();
        })
        .then(function (data) {
          label.textContent = 'Added';
          btn.classList.add('is-added');
          closeQa();
          // Let other components (header count, shipping bar) know.
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          // Repaint the drawer so the new line item and totals appear. This
          // also removes the accessory from the upsell list, since the Liquid
          // skips anything already in the cart.
          setTimeout(function () {
            if (!patchDrawer(data.sections)) window.location.reload();
            accBusy = false;
          }, 450);
        })
        .catch(function (err) {
          label.textContent = (err && err.description) ? 'Unavailable' : 'Try again';
          setTimeout(function () {
            label.textContent = original;
            btn.disabled = false;
            accBusy = false;
          }, 1600);
        });
    });

  })();
  } catch(e) { console.error(e); }
})();

})();
